import styled from 'styled-components';
import { colors } from '@dexma/ui-components';

export const StyledAlertWarning = styled.div`
    background-color: ${colors.amber};
    width: 48px;
    height: 40px;
    position: absolute;
    border-radius: 4px;
    top: 4px;
    left: 4px;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
`;
